module.exports = __webpack_public_path__ + "img/logo-red.20bce4ce.svg";